import { useEffect, useRef, useState } from "react";
import { useInView, useReducedMotion } from "framer-motion";

const MQ = "(min-width: 768px)";
const allowVideo = () => window.matchMedia(MQ).matches && !navigator.connection?.saveData;

/* Subtle cinematic background: static poster everywhere, compressed looping video on desktop/tablet only, lazy + paused off-screen */
export default function VideoBg({ name, opacity = 0.5, overlay = "bg-[#0A0A0B]/50", position = "center", eager = false, webm = true, className = "" }) {
  const ref = useRef(null);
  const vid = useRef(null);
  const near = useInView(ref, { margin: "500px 0px", once: true });
  const inView = useInView(ref, { amount: 0.02 });
  const reduce = useReducedMotion();
  const [ok, setOk] = useState(false);
  const [playing, setPlaying] = useState(false);
  useEffect(() => { const mq = window.matchMedia(MQ); const f = () => setOk(allowVideo()); f(); mq.addEventListener("change", f); return () => mq.removeEventListener("change", f); }, []);
  const useVideo = ok && !reduce && near;
  useEffect(() => { const v = vid.current; if (!v) return; if (inView) v.play().catch(() => {}); else v.pause(); }, [inView, useVideo]);
  return (
    <div ref={ref} className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true" data-testid={`video-bg-${name}`}>
      <img src={`/video/${name}.jpg`} srcSet={`/video/${name}-m.jpg 720w, /video/${name}.jpg 1280w`} sizes="100vw" alt="" loading={eager ? "eager" : "lazy"} fetchPriority={eager ? "high" : "auto"} decoding="async" className="absolute inset-0 h-full w-full object-cover" style={{ opacity, objectPosition: position }} />
      {useVideo && (
        <video ref={vid} muted loop playsInline autoPlay preload="none" disablePictureInPicture disableRemotePlayback tabIndex={-1} poster={`/video/${name}.jpg`} onPlaying={() => setPlaying(true)} className="absolute inset-0 h-full w-full object-cover transition-opacity duration-1000" style={{ opacity: playing ? opacity : 0, objectPosition: position }} data-testid={`video-${name}`}>
          {webm && <source src={`/video/${name}.webm`} type="video/webm" />}
          <source src={`/video/${name}.mp4`} type="video/mp4" />
        </video>
      )}
      <div className={`absolute inset-0 ${overlay}`} />
    </div>
  );
}
